import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type { Observable } from "rxjs";
import { map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { rewardsAuthApiClientToken } from "../../../tokens";
import type { ProgramAccountEntity } from "../entities/RewardsProgramAccountEntity";
import { ProgramAccountSchema } from "../entities/RewardsProgramAccountSchema";
import type { RewardsProgramAccountQueryParams } from "../types";

@singleton()
class RewardsProgramAccountApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    public getRewardsProgramAccount(
        queryParams: RewardsProgramAccountQueryParams
    ): Observable<ProgramAccountEntity> {
        return this.apiClient
            .get({
                url: "/general/getRewardsProgramAccount",
                responseType: "json",
                queryParams,
            })
            .pipe(
                map((response) => create(response.body, ProgramAccountSchema))
            );
    }
}

export default RewardsProgramAccountApiService;
